import { ReactNode } from "react";

import Modal from "components/modal/Modal";
import { Button } from "components/button/Button";
import { useRootStore } from "store";

type Props = {
  onDismiss: () => void;
  onConfirm: () => void;
  children: ReactNode;
  isLoading?: boolean;
};

export default function UploadConfirmationModal({
  onDismiss,
  onConfirm,
  children,
  isLoading
}: Props) {
  const { customerName } = useRootStore((state) => state.customers.workingCustomer);

  return (
    <Modal
      onDismiss={onDismiss}
      modalTitle="upload confirmation modal"
      size="sm"
      header={
        <div className="mb-5">
          <h2 className="fpx-20 fw-lighter">
            Ladda upp fil till:{" "}
            <span className="fw-bolder">{customerName}</span>
          </h2>
        </div>
      }
      footer={
        !isLoading && (
          <div className="d-flex justify-content-between mt-5">
            <Button onClick={onDismiss} color="outline">
              Avbryt
            </Button>
            <Button color="tertiary" onClick={onConfirm}>
              Bekräfta
            </Button>
          </div>
        )
      }
    >
      {children}
    </Modal>
  );
}
